import { render, staticRenderFns } from "./baseStar.vue?vue&type=template&id=05ef4a8f&scoped=true&"
import script from "./baseStar.vue?vue&type=script&lang=js&"
export * from "./baseStar.vue?vue&type=script&lang=js&"
import style0 from "./baseStar.vue?vue&type=style&index=0&id=05ef4a8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ef4a8f",
  null
  
)

export default component.exports